import { useState } from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import { Button } from '@/components/ui/button'
import { Loader2, Save, X } from 'lucide-react'
import { useIsMobile } from '@/hooks/use-mobile'
import { PortalPageHeader } from './ui/PortalPageHeader'
import { useJournalistProfile } from './profile/useJournalistProfile'
import { ProfileHero } from './profile/ProfileHero'
import { ProfileOverviewTab } from './profile/ProfileOverviewTab'
import { ProfileCredentialsTab } from './profile/ProfileCredentialsTab'
import { ProfileCoverageTab } from './profile/ProfileCoverageTab'
import { ProfileSettingsTab } from './profile/ProfileSettingsTab'

export function PortalProfileView() {
  const state = useJournalistProfile()
  const [tab, setTab] = useState('overview')

  return (
    <div className="max-w-5xl space-y-6 pb-24">
      <PortalPageHeader
        title="My Profile"
        description="Your journalist identity, credentials and coverage record."
      />

      <ProfileHero state={state} />

      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <TabsList className="w-full justify-start overflow-x-auto">
          <TabsTrigger value="overview">Overview</TabsTrigger>
          <TabsTrigger value="credentials">Credentials</TabsTrigger>
          <TabsTrigger value="coverage">Coverage</TabsTrigger>
          <TabsTrigger value="settings">Settings</TabsTrigger>
        </TabsList>

        <TabsContent value="overview" className="mt-5">
          <ProfileOverviewTab state={state} />
        </TabsContent>
        <TabsContent value="credentials" className="mt-5">
          <ProfileCredentialsTab state={state} />
        </TabsContent>
        <TabsContent value="coverage" className="mt-5">
          <ProfileCoverageTab state={state} />
        </TabsContent>
        <TabsContent value="settings" className="mt-5">
          <ProfileSettingsTab state={state} />
        </TabsContent>
      </Tabs>

      {(state.editing || state.dirty) && (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 flex items-center gap-3 px-4 py-3 rounded-xl border border-border bg-card shadow-lg animate-in slide-in-from-bottom-4">
          <span className="text-xs text-muted-foreground">
            {state.dirty ? 'You have unsaved changes' : 'Editing profile'}
          </span>
          <Button variant="ghost" size="sm" onClick={state.cancelEdit} disabled={state.saving} className="gap-1.5">
            <X className="w-3.5 h-3.5" /> Cancel
          </Button>
          <Button size="sm" onClick={state.save} disabled={state.saving || !state.dirty} className="gap-1.5">
            {state.saving ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Save className="w-3.5 h-3.5" />}
            Save changes
          </Button>
        </div>
      )}
    </div>
  )
}
